import React from "react"

export default function BookLayout({ children, pageName }) {
    return (
        <div>
            {children}
        </div>
    )
}
